/** Raised when a composition operation type is not recognized by the domain. */
export class UnsupportedCompositionOperationError extends Error {
    constructor(operationType: string) {
        super('Unsupported composition operation: ' + operationType);
        this.name = 'UnsupportedCompositionOperationError';
        // Required for correct instanceof checks when targeting ES5
        Object.setPrototypeOf(this, UnsupportedCompositionOperationError.prototype);
    }
}
